import React, { createContext, useContext, useEffect, useState } from "react";
import { SUPPORTED_LOCALES, tFor } from "./i18n";
import { api } from "./api";

const LocaleContext = createContext(null);
const STORAGE_KEY = "moviohub_locale";
const COUNTRY_KEY = "moviohub_country";

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => localStorage.getItem(STORAGE_KEY) || "en");
  const [country, setCountry] = useState(() => localStorage.getItem(COUNTRY_KEY) || "US");
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    if (detected) return;
    if (localStorage.getItem(STORAGE_KEY)) {
      setDetected(true);
      return;
    }
    api.get("/geo")
      .then((r) => {
        const loc = SUPPORTED_LOCALES.includes(r.data.locale) ? r.data.locale : "en";
        setLocale(loc);
        setCountry(r.data.country || "US");
        localStorage.setItem(COUNTRY_KEY, r.data.country || "US");
      })
      .catch(() => {})
      .finally(() => setDetected(true));
  }, [detected]);

  const changeLocale = (loc) => {
    setLocale(loc);
    localStorage.setItem(STORAGE_KEY, loc);
  };

  const t = tFor(locale);

  return (
    <LocaleContext.Provider value={{ locale, country, setLocale: changeLocale, t }}>
      {children}
    </LocaleContext.Provider>
  );
}

export const useLocale = () => useContext(LocaleContext);
